export enum Env {
  Development = 'development',
  Staging = 'staging',
  PreProd = 'preprod',
  Demo = 'demo',
  Production = 'production',
  Test = 'test'
}
